import styled from "styled-components";

export const AllNotesListStyle = styled.div`
&
{
    display: grid;  
    grid-gap: 20px;
    grid-template-columns: repeat(auto-fill, 18rem);
    justify-content: center;
}
`